import React, { Component } from 'react'
import styled from 'styled-components'
import { Icon } from './'
import Link from 'react-router-dom/Link'
import withRouter from 'react-router-dom/withRouter'
import { startsWith } from 'lodash'

const FooterWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 768px;
  padding: 0 14px;
  & > a {
    flex-basis: calc(25% - 10px);
    padding: 14px 0;
  }
  z-index: ${props => (props.zIndex ? props.zIndex : '99999999')};
`
const IconWrap = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${props =>
    props.active &&
    `
    & p{
      color:#124b5f;
    }
    &>svg path{
      &:first-child{
        fill: #124b5f;
      }
      &:nth-child(2){
        stroke: #124b5f;
      }
    }
  `};
`
class Footer extends Component {
  state = {}
  render() {
    const {
      location: { pathname },
      zIndex
    } = this.props
    return (
      <FooterWrap zIndex={zIndex}>
        <IconWrap to="/home" active={startsWith(pathname, '/home') ? 1 : 0}>
          <Icon icon="home" />
          {/* <XXMText color="#a0b7bf">Home</XXMText> */}
        </IconWrap>
        <IconWrap to="/products" active={startsWith(pathname, '/products') ? 1 : 0}>
          <Icon icon="products" />
          {/* <XXMText color="#a0b7bf">Search</XXMText> */}
        </IconWrap>
        <IconWrap to="/lists" active={startsWith(pathname, '/lists') ? 1 : 0}>
          <Icon icon="lists" />
          {/* <XXMText color="#a0b7bf">List</XXMText> */}
        </IconWrap>
        {/* <IconWrap to="/meals" active={startsWith(pathname,'/meals')  ? 1 : 0}>
          <Icon icon="meals" />
          <XXMText color="#a0b7bf">Meals</XXMText>
        </IconWrap> */}
      </FooterWrap>
    )
  }
}

export default withRouter(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js